import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img src="/pinaka-logo.png" alt="Pinaka Education" className="h-10 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground">
              Aim · Achieve · Succeed
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Online test series for Class 10, 11, 12, JEE & NEET students.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-outfit font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/test-series" className="hover:text-primary transition-colors">Test Series</Link></li>
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/login" className="hover:text-primary transition-colors">Login</Link></li>
              <li><Link to="/register" className="hover:text-primary transition-colors">Sign Up</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-outfit font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/refund-policy" className="hover:text-primary transition-colors">Refund Policy</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="mailto:support@pinakaclasses.com" className="hover:text-primary transition-colors">
                  support@pinakaclasses.com
                </a>
              </li>
              <li>
                <a href="https://wa.me/918601375676" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  +91 86013 75676
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center pt-8 mt-8 border-t border-border text-muted-foreground text-sm">
          © {new Date().getFullYear()} Pinaka Education. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
